import { useState } from "react";
import { Pencil, Check, X, Loader2 } from "lucide-react";
import { MAX_NAME } from "../lib/api";

// `text` with the first case-insensitive occurrence of `q` marked (the Your Ducks search).
export const Marked = ({ text, q, testId }) => {
  const at = q ? text.toLowerCase().indexOf(q.toLowerCase()) : -1;
  if (at < 0) return text;
  return (
    <>
      {text.slice(0, at)}
      <mark data-testid={testId} className="rounded bg-primary/70 text-foreground px-0.5">{text.slice(at, at + q.length)}</mark>
      {text.slice(at + q.length)}
    </>
  );
};

// Card title with a quick inline rename (pencil → input → Enter/✓ saves, Esc/✕ cancels).
export const CardTitle = ({ c, i, prefix, fallback, actions, canRename, highlight }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const shown = actions.renamed?.[c.id] ?? c.name;
  const saving = actions.busy?.renaming === c.id;

  const submit = async (e) => {
    e.preventDefault();
    if (await actions.rename(c, value)) setEditing(false);
  };

  if (editing) {
    return (
      <form data-testid={`${prefix}-rename-form-${i}`} className="flex items-center gap-1" onSubmit={submit}>
        <input
          autoFocus
          data-testid={`${prefix}-rename-input-${i}`}
          value={value}
          maxLength={MAX_NAME}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === "Escape" && setEditing(false)}
          className="h-7 flex-1 min-w-0 rounded-lg border border-border bg-background px-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-accent"
        />
        <button type="submit" data-testid={`${prefix}-rename-save-${i}`} disabled={saving} className="rounded-full bg-accent text-accent-foreground p-1 disabled:opacity-50" title="Save">
          {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />}
        </button>
        <button type="button" data-testid={`${prefix}-rename-cancel-${i}`} onClick={() => setEditing(false)} className="rounded-full border border-border p-1" title="Cancel">
          <X className="h-3.5 w-3.5" />
        </button>
      </form>
    );
  }
  return (
    <p className="text-sm font-semibold truncate flex items-center gap-1" data-testid={`${prefix}-title-${i}`}>
      <span className="truncate">{highlight ? <Marked text={shown || fallback} q={highlight} testId={`${prefix}-match-${i}`} /> : shown || fallback}</span>
      <span className="font-mono2 text-xs text-muted-foreground font-normal shrink-0">Rev {c.version || 1}</span>
      {canRename && (
        <button
          type="button"
          data-testid={`${prefix}-rename-btn-${i}`}
          onClick={() => { setValue(shown || ""); setEditing(true); }}
          className="shrink-0 rounded-full p-1 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          title="Rename"
        >
          <Pencil className="h-3 w-3" />
        </button>
      )}
    </p>
  );
};
